import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './Select.module.sass';

const Select = ({ val = '', onChange, children, classes = '', required = false, name = '' }) => {
  return (
    <select name={name} value={val} onChange={onChange} required={required} className={cn(styles.select, classes)}>
      {children}
    </select>
  );
};

Select.propTypes = {
  val: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node,
  classes: PropTypes.string,
  required: PropTypes.bool,
};

export default Select;
